const cmsBase = (import.meta.env.VITE_STRAPI_API_URL || 'https://cms.kuahr.com').replace(/\/$/, '');
export type Row = Record<string, unknown>;
export function row(value: unknown): Row { return value && typeof value === 'object' && !Array.isArray(value) ? value as Row : {}; }
export function rows(value: unknown): Row[] { return Array.isArray(value) ? value.map(row) : []; }
export function text(value: unknown): string { return typeof value === 'string' ? value : ''; }
export function mediaUrl(value: unknown): string {
  const url = text(value) || text(row(value).url);
  if (url.startsWith('/uploads/')) return `${cmsBase}${url}`;
  try { const parsed = new URL(url); return ['https:', 'http:'].includes(parsed.protocol) ? parsed.href : ''; } catch { return ''; }
}
export async function collection(name: string, params: Record<string, string> = {}): Promise<Row[]> {
  const query = new URLSearchParams({ 'filters[site][$eq]': 'result', 'pagination[pageSize]': '100', ...params });
  try {
    const response = await fetch(`${cmsBase}/api/${name}?${query}`, { signal: AbortSignal.timeout(10000) });
    if (!response.ok) throw new Error(`CMS returned ${response.status}`);
    const body = await response.json();
    return rows(body.data);
  } catch (error) { console.warn('[strapi] Content unavailable; using page fallback.', error); return []; }
}
// Preserve the existing view interface while using Strapi media URLs.
export function urlForImage(source: unknown) {
  const builder = { width(_value: number) { return builder; }, height(_value: number) { return builder; }, url() { return mediaUrl(source); } };
  return builder;
}
